export function formatDate(dateVar) {
        console.log(dateVar)
        const parsedDate = new Date(dateVar.replace(/-/g, '\/')) // regex to replace '-' with / so that it isn't 1 day off. 
        console.log(parsedDate)
        const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
        
        const month = months[parsedDate.getMonth()]
        const day = parsedDate.getDate();
        const year = parsedDate.getFullYear();
        
        return `${month} ${day}, ${year}`;
      }